import axiosClient from "./axiosClient";
import { ApiResponse } from "models";
import {
  Subscription,
  SubscriptionPayload,
  StoreList,
} from "../models/subscription";

const subscriptionApi = {
  getSubscriptionList(data: SubscriptionPayload): Promise<any> {
    return axiosClient.get(`/sahlSubscription/getSahlSubscription`, {
      params: {
        page: data.page,
        limit: data.limit,
        search: data.search,
        region: data.region,
        sortField: data.sortName,
        sortType: data.sortType,
      }
    });
  },

  getAllSubscription(): Promise<any> {
    return axiosClient.get(`/sahlSubscription/getSahlSubscription`, {
      params: { disablePagination: true }
    });
  },

  getSubscriptionById(data: SubscriptionPayload): Promise<any> {
    return axiosClient.get(`/sahlSubscription/getSahlSubscription`, {
      params: { _id: data.id }
    });
  },

  updateSubscription(data: Subscription): Promise<ApiResponse> {
    const payload = {
      _id: data?._id,
      planName: data.planName,
      description: data?.description,
      regionalPrices: data?.regionalPrices,
    };
    return axiosClient.post(`/sahlSubscription/addUpdateSahlSubscription`, payload);
  },

  deleteSubscription(data: any): Promise<ApiResponse> {
    return axiosClient.delete(`/sahlSubscription/deleteSahlSubscription`, {
      params: { _id: data._id }
    });
  },

  storeListApi(data: StoreList): Promise<ApiResponse> {
    return axiosClient.get(`/store/getStoreByBrandId`, {
      params: { brandId: data.brandId }
    });
  },
};

export default subscriptionApi;
